export enum TargetType {
	TJD = 'TJD',
	JOB_STARTED = 'JobStarted',
	JOB_COMPLETED = 'JobCompleted',
	JOB_CREATED = 'JobCreated',
	RECORD_CHANGE = 'RecordChange',
	DISPLAY_MESSAGE = 'DisplayMessage',
}
